import { ReactElement } from 'react';

interface NumberInputProps {
  value: string | undefined;
  placeholder?: string;
  onChange: (value: number) => void;
  style?: React.CSSProperties;
}

export const NumberInput = ({
  value,
  placeholder,
  onChange,
  style
}: NumberInputProps): ReactElement => {
  return (
    <div>
      <input
        type="text"
        style={{
          ...(style || {})
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const numericValue = e.target.value.replace(/[^0-9]/g, '');
          onChange(numericValue ? +numericValue : 0);
        }}
      />
    </div>
  );
};
